exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-container.padding[data-v-2dea5954]{padding-bottom:15rem}@media (max-width:767px){.home-container.padding[data-v-2dea5954]{padding-bottom:17rem}}", ""]);

// exports
